<template>
  <div class="member">
    <ImmersionHeader
      ref="ImmersionHeader"
      :uiTheme="isGlobaloneStyle && 'globalOne'"
      :isShowBackBtn="isShowBackBtn"
      :isShowRightButton="isShowRightButton"
      :rightText="$t('FoodC_subscription_Wlpe_bBkf')"
      :title="brandName || ' '"
      :leftIconClassName="leftIconClassName"
      :blackTheme="isGlobaloneStyle ? false : blackTheme"
      @BackCK="headerBackCK"
      @rightBtnCK="rightBtnCK"
    />
    <!--Loading-->
    <LoadingMask v-if="loading" />
    <!-- 登录 -->
    <div v-if="isLogin">
      <template v-if="!noPageInfo">
        <div :key="pageIndexKey">
          <member-v2 v-if="isGlobaloneStyle" :pageInfo="pageInfo" :headerHeight="headerHeight" />
          <member-v1
            v-else
            :pageInfo="pageInfo"
            :headerHeight="headerHeight"
            :initData="initCodeData"
            :allVersionJudge="allVersionJudge"
          />
        </div>
      </template>
      <div v-else-if="loading" class="bg_loading">
        <LoadingMask :type="loadingType" />
      </div>
      <template v-else-if="isShowRetryPage">
        <RetryPage @retry="checkLogin" />
      </template>
      <template v-else-if="noPageInfo">
        <!-- 活动结束 -->
        <ActivityEnd />
      </template>
      <LoadingMask v-if="requestLoading" />
      <MemberDialog v-model="isShowDialog" :dialogData="dialogData" />
    </div>
    <!-- 未登录 -->
    <LogOut v-else @update-login="updateLogin" />
  </div>
</template>

<script>
import { get, isEmpty } from 'lodash-es'
import { mapMutations, mapActions, mapState } from 'vuex'
import { getMembershipDetail, getPopDialog } from '@/api/member/index.js'
import { getPageFromParam } from './common/utils.js'
import apiConfig from '@/common/js/apiConfig'
import { CHECK_VERSION_MAP, isVersionSupportMap } from '@/common/js/checkAppVersion.js'
import { membershipLandingSw } from './trackEvent.js'
import {
  MODULE_TYPE,
  lockSalesChannelNum,
  GLOBAL_EMBED_CUSTOMER,
  POP_DIALOG_POSITION,
  BACK_ICON_NAME,
  IS_FIRST_ENTRY,
  HISTORY_PAGE,
} from './common/enumsUtil.js'
import { switchToRider, autoSelectAddress } from '@/common/js/bridge.js'
import { debounce } from '@/common/js/utils'
import memberV1 from '@/page/member/member-v1.vue'
import memberV2 from '@/page/member/member-v2.vue'
import LogOut from './components/logOut/index.vue'
import ActivityEnd from './components/activityEnd/index.vue'
import MemberDialog from './components/memberDialog/index.vue'
import LoadingMask from '@/components/loading/loading-mask.vue'
import ImmersionHeader from '@/components/immersionHeader/index.vue'
import SpecialtyPro from './components/specialtyPro/index.vue'
import RetryPage from './components/retryPage/index.vue'
import UpgradeWarnDialog from './components/upgradeWarnDialog/index.vue'
import { util } from '@didi/soda-common'
import mixin from '@/page/member/mixins.js'

const { env } = util
// 本期先不迁移v2，避免用户已经打开tab，导致路由不一致问题
const SUBSCRIBE_LOADING_PAGE = '/subscribeLoading'

export default {
  components: {
    memberV1,
    memberV2,
    LogOut,
    ActivityEnd,
    MemberDialog,
    LoadingMask,
    ImmersionHeader,
    SpecialtyPro,
    RetryPage,
    UpgradeWarnDialog,
  },
  mixins: [mixin],
  provide() {
    return {
      initCodeData: this.initCodeData,
    }
  },
  data() {
    return {
      isLogin: false,
      loading: false,
      requestLoading: false,
      headerHeight: 0,
      isShowUpgradeWarn: false,
      MODULE_TYPE,
      isShowDialog: false,
      dialogData: {
        imgUrl: '',
        redirect: '',
      },
      leftIconClassName: BACK_ICON_NAME,
      membership: {},
      pageInfo: {},
      allVersionJudge: {},
      saleInfo: {},
      extraInfo: {},
      headInfo: {},
      blackTheme: true,
      isShowRetryPage: false,
      itemType: '',
      isShowRightButton: false, // 如果是升级pro页面，不展示购买记录 || 新版样式不展示右侧按钮
      pageIndexKey: 1, // 组件key
    }
  },
  computed: {
    ...mapState(['globalParams']),
    brandName() {
      return this.membership?.brandName
    },
    isShowBackBtn() {
      return !this.isFromTab
    },
    getNoSubscribe() {
      const noSubscribe = this.params?.noSubscribe || 0
      return noSubscribe * 1
    },
    noPageInfo() {
      return isEmpty(this.pageInfo)
    },
    isCanSubscribe() {
      return this.membership?.canSubscribe
    },
    isShowSubscribeLoading() {
      return (
        this.isCanSubscribe &&
        this.isNoBuySubscriptionStatus &&
        +this.membership?.lockStatus === 2 &&
        +this.membership?.lockSalesChannel === lockSalesChannelNum.renew
      )
    },
    // 订单状态上锁=2 && 锁定渠道!=续费
    isShowRepeatBuyDialog() {
      return (
        +this.membership?.lockStatus === 2 &&
        +this.membership?.lockSalesChannel !== lockSalesChannelNum.renew
      )
    },
    // 老版本 & 嵌入端 & 出行订单 (展示一个按钮)
    isOldGlobalTravel() {
      return !this.isJumpVersionApp && this.isGlobalJumpTravelLink
    },
    // 版本<7.4.84 & 安卓 & 嵌入端 & 出行订单 & 在非SA的侧边栏进入 (展示一个按钮)
    isOldAndroidSidebarGlobalTravel() {
      return (
        !this.isAndroidBarJumpVersionApp &&
        this.isAndroid &&
        this.isGlobalJumpTravelLink &&
        this.isFromEmbedSidebar
      )
    },
    // 可以支持跳转的版本
    isJumpVersionApp() {
      return this.allVersionJudge?.[CHECK_VERSION_MAP.CAN_JUMP_VERSION.KEY]
    },
    // 判断是不是在嵌入端有出行订单上的锁
    isGlobalJumpTravelLink() {
      return (
        this.isGlobalEmbedCustomer &&
        +this.membership?.lockSalesChannel == lockSalesChannelNum.channelTravel // eslint-disable-line eqeqeq
      )
    },
    // 在ImmersionHeader组件内进行过一次获取公参的操作，所以这里直接使用了
    isGlobalEmbedCustomer() {
      return this.$store?.state?.globalParams?.data?.clientType === GLOBAL_EMBED_CUSTOMER
    },
    // 兼容安卓嵌入端非SA侧边栏直跳问题的版本
    isAndroidBarJumpVersionApp() {
      return this.allVersionJudge?.[CHECK_VERSION_MAP.RIDE_SIDE_BAR_JUMP_VERSION.KEY]
    },
    // 是不是Android
    isAndroid() {
      return env.isAndroid
    },
  },
  async created() {
    if (apiConfig.isDev) {
      // 有登录验证，所以在开发环境将登录校验去掉
      this.isLogin = true
      this.allVersionJudge = await isVersionSupportMap(CHECK_VERSION_MAP, apiConfig.isDev)
      this.requestPageInfo()
    } else {
      this.checkLogin()
    }
    // 监听tab切换
    this.tabChangeMonitor()
  },
  async mounted() {
    await this.getGlobalParams()
    this.setHeaderHeight()
  },
  methods: {
    ...mapMutations(['SET_MEMBERSHIP_DETAIL', 'SET_MEMBERSHIP_ALL_DATA']),
    ...mapActions({
      getGlobalParams: 'getGlobalParams',
    }),
    // 请求页面数据
    requestPageInfo() {
      this.initCodeData()
      this.getPopDialogRequest()
    },
    checkLogin() {
      this.loading = true
      Soda.getUserInfo({}, async data => {
        this.loading = false
        // 判断是否有用户token
        if (data && get(data, 'data.token', '')) {
          this.isLogin = true
          // 更改支付方式的bridge进入版本
          this.allVersionJudge = await isVersionSupportMap(CHECK_VERSION_MAP)
          this.loading = true
          const success = await this.coincidenceJump()
          this.loading = false
          if (!success) {
            // 出现重试兜底页面
            this.isShowRetryPage = true
            return
          }
          this.requestPageInfo()
        }
      })
    },
    tabChangeMonitor() {
      if (this.isFromTab && Soda.customer) {
        this.toast = this.$createToast({
          type: 'loading',
          effect: 'light',
          time: 0,
        })

        Soda.customer.triggerTabShowEvent = debounce(async () => {
          this.toast.show()
          await this.initCodeData()
          this.subscribeLoadingGoBack()
          // 刷新数据
          this.pageIndexKey++
          this.toast.hide()
        }, 300)
      }
    },
    async initCodeData() {
      this.loading = true
      const res = await getMembershipDetail({
        noSubscribe: this.getNoSubscribe,
      })
      if (res?.errno === 0) {
        this.pageInfo = res?.data
        this.membership = this.pageInfo?.membership || {}
        this.saleInfo = this.pageInfo?.saleInfo || {}
        this.extraInfo = this.pageInfo?.extraInfo || {}
        this.headInfo = this.pageInfo?.headInfo || {}

        this.SET_MEMBERSHIP_DETAIL(this.membership)
        this.SET_MEMBERSHIP_ALL_DATA({
          paySuccessInfo: this.pageInfo?.paySuccessInfo || {},
        })
        // 续订页面: 未购买&订阅中&订单状态上锁=2&&锁定渠道=续费(15天续费周期中,扣费节点)
        if (this.isShowSubscribeLoading) {
          this.loading = false
          this.goSubscribeLoading()
          return
        }

        // 会员曝光埋点
        this.membershipLandingSwFn(MODULE_TYPE.INIT)

        // 重复购买弹窗
        if (this.isShowRepeatBuyDialog) {
          // 展示一个按钮弹窗，不支持跳转
          if (this.isOldGlobalTravel || this.isOldAndroidSidebarGlobalTravel) {
            this.getShowBuyMemberOnly()
          } else {
            // 展示两个按钮弹窗
            this.getShowBuyMemberToUrl()
          }
        }
        /** @desc 设置沉浸式头右侧按钮 */
        if (!this.isUpgradesProStatus && !this.isGlobaloneStyle) {
          this.isShowRightButton = true // 非升级pro页面 && 非新版样式 : 展示右侧购买记录按钮
        } else {
          this.isShowRightButton = false
        }
        /** @desc globalone 命中特型购买成功样式 */
        if (this.isGlobaloneStyle && this.membership?.showFirstJoinMemberStyle) {
          setTimeout(() => {
            this.$router.push({
              path: '/member/first',
              query: {
                userHeadUrl: this.headInfo?.userHeadUrl,
              },
            })
          }, 50)
        }
      } else {
        this.createErrorToast(res?.errmsg || '')
      }
      this.loading = false
      this.styleRedrawing()
    },
    createErrorToast(errmsg = '', defaultMsg = this.gettext('网络繁忙，请稍后再试')) {
      const errorToast = this.$createToast({
        txt: errmsg || defaultMsg,
        time: 2000,
        mask: false,
        type: 'error',
      })
      errorToast.show()
    },

    setHeaderHeight() {
      if (this.isFromTab) {
        this.headerHeight = this.$refs?.ImmersionHeader?.$refs?.headerBoxTab?.offsetHeight || 0
        return
      }
      this.headerHeight = this.$refs?.ImmersionHeader?.$el?.offsetHeight || 0
    },
    // 判断当前状态是否非续订中，如果不是，返回上一个页面
    subscribeLoadingGoBack() {
      const isSubscribeLoadingPath = this.$route.path === SUBSCRIBE_LOADING_PAGE
      if (isSubscribeLoadingPath && !this.isShowSubscribeLoading) {
        this.$router.go(-1)
      }
    },
    styleRedrawing() {
      this.$nextTick(() => {
        window.scrollTo(0, 1)
      })
    },
    // 是否是正在购买中，如果是跳转购买加载页面
    goSubscribeLoading() {
      this.$router?.push({
        path: SUBSCRIBE_LOADING_PAGE,
        query: {
          nativeWebUIType: 1,
          benefitId: this.membership?.benefitID,
          couponPackageStatus: this.couponPackageStatus,
          clickType: MODULE_TYPE.RULE,
          benefitType: +this.membership?.status,
          from: getPageFromParam(this.params),
          isFromTab: this.isFromTab,
        },
      })
    },
    // 重复购买弹窗不展示购买按钮
    getShowBuyMemberOnly() {
      this.$createAlert({
        type: 'alert',
        title: this.$t('FoodC_member_rIZz_EbdA'),
        content: this.$t('FoodC_member_wEQc_Appv', { brand: this.brandName }),
        confirmBtn: {
          text: this.$t('FoodC_member_qXYs_kKZA'),
          active: true,
          disabled: false,
          href: 'javascript:;',
        },
        onConfirm: () => {},
      }).show()
    },
    // 重复购买弹窗展示跳转按钮
    getShowBuyMemberToUrl() {
      this.$createAlert({
        type: 'confirm',
        title: this.$t('FoodC_member_rIZz_EbdA'),
        content: this.$t('FoodC_member_wEQc_Appv', { brand: this.brandName }),
        confirmBtn: {
          text: this.$t('FoodC_member_qXYs_kKZA'),
          active: true,
          disabled: false,
          href: 'javascript:;',
        },
        cancelBtn: {
          text: this.$t('FoodC_member_fKsy_UJNP'),
          active: false,
          disabled: false,
          href: 'javascript:;',
        },
        onConfirm: () => {},
        onCancel: () => {
          // 在嵌入端的外卖容器，跳出行首页(对应场景：因为出行订单上锁的场景)
          if (this.isJumpVersionApp && this.isGlobalJumpTravelLink) {
            switchToRider({
              url: this.membership?.lockClickUrl,
            })
            return
          }
          window.SodaBridge('openPage', {
            target: 'blank',
            url: this.membership?.lockClickUrl,
          })
        },
      }).show()
    },
    // 是否符合乘客端直跳条件
    async coincidenceJump() {
      const conformingVersion = this.allVersionJudge?.[CHECK_VERSION_MAP.CAN_PLAN_JUMP_VERSION.KEY]
      // 1、是否为嵌入端 2、版本是否符合要求，
      if (this.isFromEmbed && conformingVersion) {
        const isFirstEntry = !sessionStorage.getItem(IS_FIRST_ENTRY)
        // 3、是否调用过该bridge
        if (isFirstEntry) {
          const res = await this.autoSelectAddressBridge()
          if (res) sessionStorage.setItem(IS_FIRST_ENTRY, true)
          return res
        } else {
          return true
        }
      }
      return true
    },
    // bridge调用
    autoSelectAddressBridge() {
      return new Promise(resolve => {
        autoSelectAddress(
          {
            scene: 1,
          },
          res => {
            if (res?.data?.addressInfo?.address?.poi?.poiId) {
              resolve(true)
            } else {
              resolve(false)
            }
          },
        )
      })
    },
    updateLogin() {
      this.isLogin = true
      this.initCodeData()
    },
    // 运营位弹窗
    async getPopDialogRequest() {
      const res = await getPopDialog({
        position: POP_DIALOG_POSITION.MEMBER,
      })
      if (res?.errno === 0 && res.data?.needPopup && res?.data?.info?.imgUrl) {
        // 接口返回数据正常
        this.isShowDialog = true
        this.dialogData.imgUrl = res?.data?.info?.imgUrl
        this.dialogData.redirect = res?.data?.info?.redirect
      }
    },
    membershipLandingSwFn(module_type) {
      membershipLandingSw({
        coupon_package_status: this.couponPackageStatus,
        benefit_id: this.membership?.benefitID,
        module_type, // 1-右上角的历史记录,2-累计已省模块,3-会员权益购买按钮,4-加量包购买模块
        from: getPageFromParam(this.params),
      })
    },
    headerBackCK() {
      this.BackCK()
    },
    BackCK() {
      this.SodaBridge('closePage')
    },
    rightBtnCK() {
      // 右上角的历史记录点击
      this.membershipLandingCkFn(MODULE_TYPE.RULE)
      const origin = window?.location?.origin
      const url = origin + HISTORY_PAGE
      setTimeout(() => {
        window.SodaBridge('openPage', {
          target: 'blank',
          url,
        })
      }, 300)
    },
  },
}
</script>

<style lang="scss" scoped>
.member {
  background-color: #fff;
  min-height: 100%;
  .bg_loading {
    min-height: 100vh;
  }
}
</style>
